"use client";

import { InstrumentSummary } from "#/components/InstrumentSummary/InstrumentSummary";
import { useOption } from "#/store/options/tradePanel/option";
import { useOptionLimitPrice } from "#/store/options/tradePanel/optionLimitPrice";
import { useOptionSize } from "#/store/options/tradePanel/optionSize";
import { useOptionTradeType } from "#/store/options/tradePanel/optionTradeType";
import { createOptionInstrumentName } from "#/utils/instrument.utils";

export const TradeConfirmationOptionInstrument: React.FC = () => {
  const { optionSize } = useOptionSize();
  const { isMarket } = useOptionTradeType();
  const { option, bestBid, bestAsk } = useOption();
  const { optionLimitPriceNum } = useOptionLimitPrice();

  const isBuy = option!.isBuy;
  const bestPrice = isBuy ? bestAsk : bestBid;

  return (
    <InstrumentSummary
      isBuy={isBuy}
      size={optionSize}
      bestPrice={bestPrice}
      isMarketOrder={isMarket}
      limitPrice={optionLimitPriceNum}
      instrumentName={createOptionInstrumentName(option!)}
    />
  );
};
